import { render, staticRenderFns } from "./BuyBook.vue?vue&type=template&id=dbcbd174&scoped=true"
import script from "./BuyBook.vue?vue&type=script&lang=js"
export * from "./BuyBook.vue?vue&type=script&lang=js"
import style0 from "./BuyBook.vue?vue&type=style&index=0&id=dbcbd174&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbcbd174",
  null
  
)

export default component.exports